import CImage from "@/components/CImage";
import { ArrowRight } from "lucide-react";
import Link from "next/link";

type Props = {};

const MonthPlan = (props: any) => {
  return (
    <Link
      className="group w-full border border-secondary-400 bg-white"
      href={props.link}
    >
      <CImage src={props.image.url} width={340} height={300} crop />
      <div className="flex flex-col gap-2 bg-secondary-600 p-5 text-white transition-colors duration-300 group-hover:bg-secondary-700">
        <h5>{props.title}</h5>

        <span
          className="pt-2"
          dangerouslySetInnerHTML={{ __html: props.content }}
        />
        <p className="text-[17px]">
          ab 
          <span className="text-2xl font-bold">{props.price} €</span>/Monat
        </p>
        <div className="flex flex-row items-center gap-2 pt-4 text-lg font-bold">
          Jetzt planen
          <ArrowRight className="ml-0 h-6 w-6 transition-all duration-300 group-hover:ml-2" />
        </div>
      </div>
    </Link>
  );
};

export default MonthPlan;
